export const SentryMessages = {
    UNABLE_TO_FETCH_APP_HEADERS: "Unable to fetch App Headers"
}